
import React from 'react';
import EventList from '../components/EventList';
import MainNavbar from '../components/Navbar/MainNavbar';
import styled from 'styled-components';

const Home = () => {
  return (
    <>
      <MainNavbar />
      <DiscoverContainer>
        <EventList />
      </DiscoverContainer>
    </>
  );
};

export default Home

const DiscoverContainer = styled.main``;
